import { useMutation } from '@apollo/client/react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { GQL_RESEND_EMAIL_VALIDATION } from '~/gql/auth/auth'

/** Renvoie l'invitation d'un compte encore en attente d'activation. */
export function useResendInvitation() {
  const { t } = useTranslation()
  const [sendEmailValidation] = useMutation(GQL_RESEND_EMAIL_VALIDATION)

  return async function resendInvitation(user: { email?: string | null }) {
    if (!user.email) return
    try {
      await sendEmailValidation({ variables: { email: user.email } })
      toast.success(t('resend.email.success'))
    } catch {
      toast.error(t('resend.email.failed'))
    }
  }
}
